<template>

  <section>

    <div style="height: 10px;">&nbsp;</div>

    <div class="img" v-if="prodShow == false">
      <!-- <div style="width: 100%;background: #e6e6e6;color: black;padding-left: 10px;">商务出行专属优惠：</div> -->
      <div>
        <img src="../assets/travelAppointment1.jpg" style="width: 100%;height: 500px;" v-on:click="jumpDetail()" />
      </div>
      <div style="text-align: center;color: #ED0400;font-weight: bold;font-size: 18px;margin: 5px 0;">
        谢谢您的参与，已经为您的朋友助力优惠！
      </div>
    </div>
    <div class="img" v-if="prodShow == true">
      <!-- <div style="width: 100%;background: #e6e6e6;color: black;padding-left: 10px;">商务出行专属优惠：</div> -->
      <div>
        <img src="../assets/travelAppointment1.jpg" style="width: 100%;height: 500px;" v-on:click="jumpDetail()" />
      </div>
    </div>

    <button class="appointment" v-if="disjump == false" v-on:click="jumpDetail()"  style="display: block;margin-bottom: 10px;padding: 5px;background:#fdd948;font-weight: bold;font-size: 20px !important;color: #c7131f;">领取携程旅游候机楼门店红包</button>

    <div class="lineProd" v-if="prodShow == true && Isme == true">
      <img src="../assets/10y.jpg" style="width: 100%;height:90px;" v-if="tenCoupon == true" v-on:click="userCoupon(tenID,tenTitle)" />
      <img src="../assets/10y_1.jpg" style="width: 100%;height:90px;" v-if="othertenCoupon == true" v-on:click="userCoupon(othertenID,othertenTitle)" />
      <img src="../assets/30y.jpg" style="width: 100%;height:90px;" v-if="threetenCoupon == true" v-on:click="userCoupon(threetenID,threetenTitle)" />
      <img src="../assets/50y.jpg" style="width: 100%;height:90px;" v-if="fivetenCoupon == true" v-on:click="userCoupon(fivetenID,fivetenTitle)" />
    </div>

    <div class="lineProd" v-if="prodShow == true && Isme == true">
      <img src="../assets/couponRule.jpg" style="width: 100%;height:500px;"/>
    </div>

    <!-- <div style="width: 96%;margin: 0 2% 10px;text-align: center;font-size: 20px;color:  #2754BB;">4月10日，相约乌蒙大草原，共赏万亩杜鹃花开，只需799元，携程旅游中山候机楼门店约定您！</div> -->

    <div class="lineProd">
      <div style="display: flex;justify-content: space-around;flex-wrap: wrap;">
        <img src="../assets/26556260.jpg" v-on:click="prod('26556260')" style="border-radius: 5px;width: 100%;margin-bottom: 5px;height: 192px;" />
        <img src="../assets/28883542.jpg" v-on:click="prod('28883542')" style="border-radius: 5px;width: 100%;margin-bottom: 5px;height: 192px;" />
        <img src="../assets/29057806.jpg" v-on:click="prod('29057806')" style="border-radius: 5px;width: 100%;margin-bottom: 5px;height: 192px;" />
        <img src="../assets/29068580.jpg" v-on:click="prod('29068580')" style="border-radius: 5px;width: 100%;margin-bottom: 5px;height: 192px;" />
        <img src="../assets/28715963.jpg" v-on:click="prod('28715963')" style="border-radius: 5px;width: 100%;margin-bottom: 5px;height: 192px;" />
        <img src="../assets/22430605.jpg" v-on:click="prod('22430605')" style="border-radius: 5px;width: 100%;margin-bottom: 5px;height: 192px;" />
      </div>
      <button class="appointment" style="display: block;margin-bottom: 10px;padding: 5px;background:#ED0400;font-weight: bold;font-size: 20px !important;" v-on:click="prod('')">预约其他线路</button>
    </div>

    <div v-if="prodShow == true && Isme == true && isFriend == true" style="margin-left: 10px;">
      <Progress :percent="progress" :stroke-width="20" status="active" :stroke-color="['#FFFFFF','#ED0400']" style="width: 100%;" ><span style="color: #ED0400;">{{progressText}}</span></Progress>
    </div>

    <div class="demand" v-if="prodShow == true && appointInfo == true">
      <div style="width: 100%;background: #e6e6e6;color: black;padding-left: 10px;">预约信息填写：</div>
      <div style="width:100%;">
        <div style="padding-left:10px;"><span style="color: red;">*</span>您的称呼：(必填)</div>
        <Input v-model="name" clearable placeholder=""/>
      </div>
      <div style="width:100%;">
        <div style="padding-left:10px;"><span style="color: red;">*</span>您的联系电话：(必填)</div>
        <Input v-model="phone" type="tel" clearable placeholder=""/>
      </div>
      <div>
        <div style="padding-left:10px;"><span style="color: red;">*</span>携程旅游或线路名称：(必填)<span style="color: red;">{{isUse}}</span></div>
        <Input v-model="line" clearable type="textarea" :autosize="{minRows: 1,maxRows: 2}" placeholder="请输入携程产品编号 / 公众号营销产品线路名。" />
      </div>
      <div style="width:100%;">
        <div style="padding-left:10px;">出行人数：</div>
        <Input v-model="people" clearable placeholder=""/>
      </div>
      <div>
        <div style="padding-left:10px;">您的备注：</div>
        <Input v-model="demand" clearable type="textarea" :autosize="{minRows: 1,maxRows: 2}" placeholder="请输入您的备注:日期﹑行程﹑时间﹑人数等。" />
      </div>
    </div>

    <div class="demand" v-if="prodShow == true && appointInfo == true">
      <div style="width: 100%;background: #e6e6e6;color: black;padding-left: 10px;">优惠券使用规则：<span style="color: #2754BB;margin-left: 10px;font-size: 11px !important;color: red;font-weight: bold;" @click="rule">{{ruleShow == true?'(收起)':'(展开)'}}</span></div>
      <div v-if="ruleShow == true" style="width:100%;margin-bottom:5px;">1、【10元优惠券】适用于携程旅游官网及门店所有省内游、国内游跟团游产品，以及在候机楼门店线下购买机票产品；</div>
      <div v-if="ruleShow == true" style="width:100%;margin-bottom:5px;">2、【30元优惠券】适用于携程旅游官网及门店所有国内游跟团游产品（省内游除外），以及在候机楼门店线下购买机票产品（机票产品2人起用）；</div>
      <div v-if="ruleShow == true" style="width:100%;margin-bottom:5px;">3、【50元优惠券】适用于适用于携程旅游官网及门店国内游跟团游产品（省内游除外），以及在候机楼门店线下购买自由行产品（机票+酒店）；</div>
      <div v-if="ruleShow == true" style="width:100%;margin-bottom:5px;">4、每人按实名制验证可抢购1套优惠券，每人每单只能使用1张优惠券，转发本条链接有机会获得彩蛋福利，优惠加码，敬请期待；</div>
      <div v-if="ruleShow == true" style="width:100%;margin-bottom:5px;">5、该优惠券有效期至2021年9月30日内使用有效，仅限用于携程旅游候机楼门店线下报名使用，可电话咨询更多活动详情，0760-88880777；</div>
    </div>

    <button class="appointment" v-on:click="appointment()" style="display: block;background:#ED0400;font-weight: bold;font-size: 20px !important;" v-if="prodShow == true && appointInfo == true">分享朋友圈,可获优惠加码</button>

    <div style="width: 96%;margin: 0 2%;text-align: center;">中山候机楼丨18029902098 / 18988598006</div>

  </section>
</template>

<script>
  import flightApi from '../request/flightApi';
  import baseTool from '../utils/baseFunction';
  import addressApi from '../request/addressApi';
  import userApi from '../request/userApi';
  import axios from 'axios';
  export default {
    name: 'TravelAppointment',
    data() {
      return {
        demand:'',
        line:'',
        name:'',
        phone:'',
        people:'',
        ruleShow:false,
        prodShow:true,
        progress:0,
        progressText:'',
        Isme: false,
        lineProd:false,
        appointInfo:false,
        isFriend:false,
        cardList:[],
        tenCoupon:false,
        tenID:'',
        tenTitle:'',
        othertenCoupon:false,
        othertenID:'',
        othertenTitle:'',
        threetenCoupon:false,
        threetenID:'',
        threetenTitle:'',
        fivetenCoupon:false,
        fivetenID:'',
        fivetenTitle:'',
        disjump:false,
        usercoupon:'',
        isUse:'',
      };
    },
    components: {},
    mounted() {
      document.querySelector('body').setAttribute('style', 'background-color:#EAF3FA;overflow-y: scroll;height: auto;');
      // document.querySelector('body').setAttribute('style', 'background-color:#ED0400;overflow-y: scroll;height: auto;');
      this.getphoneType();
      this.lineProd = true;
      if(this.$route.params.openid && this.$route.params.openid.length && this.$route.params.openid == 0){
        this.prodShow = true;
        this.Isme = true;
        userApi.GetCardList(this.$store.state.user.OpenId).then(getcardRes => {
          console.log('getcardRes',getcardRes)
          this.cardList = getcardRes.data;
          if(getcardRes.success == true){
            this.disjump = false;
            this.tenCoupon = false;
            this.othertenCoupon = false;
            this.threetenCoupon = false;
            this.fivetenCoupon = false;

            getcardRes.data.forEach(cardObj => {

              if(cardObj.CardID == 3 && cardObj.CardStatu == 0){
                this.tenCoupon = true;
                this.tenID = cardObj.CardID;
                this.tenTitle = cardObj.Caedinfo.CardTitle;
                this.disjump = true;
              }
              if(cardObj.CardID == 4 && cardObj.CardStatu == 0){
                this.threetenCoupon = true;
                this.threetenID = cardObj.CardID;
                this.threetenTitle = cardObj.Caedinfo.CardTitle;
                this.disjump = true;
              }
              if(cardObj.CardID == 6 && cardObj.CardStatu == 0){
                this.othertenCoupon = true;
                this.othertenID = cardObj.CardID;
                this.othertenTitle = cardObj.Caedinfo.CardTitle;
                this.disjump = true;
              }
              if(cardObj.CardID == 5 && cardObj.CardStatu == 0){
                this.fivetenCoupon = true;
                this.fivetenID = cardObj.CardID;
                this.fivetenTitle = cardObj.Caedinfo.CardTitle;
                this.disjump = true;
              }

            })

          }
          else{
            this.disjump = false;
          }
        })
      }
      if (this.$route.params.openid && this.$route.params.openid.length && this.$route.params.openid != 0){
        this.prodShow = false;
        // if(this.$route.params.openid != this.$store.state.user.OpenId){
          flightApi.saveSearchFlightRecord1(this.$store.state.user.OpenId,this.$route.params.openid,1, baseTool.formatterDate(new Date()),'分享朋友圈记录',this.phoneType).then(sucRes => {
            if(this.$route.params.openid != this.$store.state.user.OpenId){
              this.progress = 0;
              // this.Isme = false;
            }
            else{
              this.prodShow = true;
              this.Isme = true;
              this.appointInfo = true;
              this.lineProd = false;
              this.isFriend = true;


              userApi.GetCardList(this.$store.state.user.OpenId).then(getcardRes => {
                console.log('getcardRes',getcardRes)
                this.cardList = getcardRes.data;
                if(getcardRes.success == true){
                  this.disjump = false;
                  this.tenCoupon = false;
                  this.othertenCoupon = false;
                  this.threetenCoupon = false;
                  this.fivetenCoupon = false;

                  getcardRes.data.forEach(cardObj => {

                    if(cardObj.CardID == 3 && cardObj.CardStatu == 0){
                      this.tenCoupon = true;
                      this.tenID = cardObj.CardID;
                      this.tenTitle = cardObj.Caedinfo.CardTitle;
                      this.disjump = true;
                    }
                    if(cardObj.CardID == 4 && cardObj.CardStatu == 0){
                      this.threetenCoupon = true;
                      this.threetenID = cardObj.CardID;
                      this.threetenTitle = cardObj.Caedinfo.CardTitle;
                      this.disjump = true;
                    }
                    if(cardObj.CardID == 6 && cardObj.CardStatu == 0){
                      this.othertenCoupon = true;
                      this.othertenID = cardObj.CardID;
                      this.othertenTitle = cardObj.Caedinfo.CardTitle;
                      this.disjump = true;
                    }
                    if(cardObj.CardID == 5 && cardObj.CardStatu == 0){
                      this.fivetenCoupon = true;
                      this.fivetenID = cardObj.CardID;
                      this.fivetenTitle = cardObj.Caedinfo.CardTitle;
                      this.disjump = true;
                    }

                  })

                }
                else{
                  this.disjump = false;
                }
              })

              // if(sucRes.data <= 10){

              //   this.progress = sucRes.data*2;
              // }
              // else if(sucRes.data <= 20){
              //   this.progressText='努力';
              //   this.progress = sucRes.data*2;
              // }
              // else if(sucRes.data <= 30){
              //   this.progressText='努力加油';
              //   this.progress = sucRes.data*2;
              // }
              // else if(sucRes.data <= 40){
              //   this.progressText='差一点点';
              //   this.progress = sucRes.data*2;
              // }
              if(sucRes.data < 50){
                this.progressText='已经有'+sucRes.data+'个朋友为您优惠加码！';
                this.progress = sucRes.data*2;
              }
              else{
                this.progress = 100;
                this.progressText='成功翻倍！(已经有'+sucRes.data+'个朋友为您优惠加码)';
              }

            }
          });
        // }
      }
      this.getUserAddress();
      this.shopFriend();
    },
    activated() {},
    methods: {
      getphoneType(){
        //获取userAgent信息
        var userAgentStr = navigator.userAgent;
        var iPhone = new RegExp("iPhone");
        var Android = new RegExp("Android");;
        if(iPhone.test(userAgentStr)){
          this.phoneType = "iPhone";
        }
        else if(Android.test(userAgentStr)){
          this.phoneType = userAgentStr.split('(Linux; Android ')[1].split('; ')[1].split(' Build')[0]
        }
      },
      getUserAddress() {
        // 获取地址列表
        userApi.getUserData(this.$store.state.user.OpenId).then(sucRes =>{
          if (sucRes.success && sucRes.totalCount > 0) {
            this.name = sucRes.data.RealName;
            this.phone = sucRes.data.Mobile;
          }
        })
        // addressApi.getAddressList(this.$store.state.user.OpenId, '').then(sucRes => {
        //   if (sucRes.success && sucRes.data.length > 0) {
        //     sucRes.data.forEach(item => {
        //       if (item.IsDefault == true) {
        //         this.name = item.Contact;
        //         this.phone = item.Mobile;
        //       }
        //     });
        //   }
        // });
      },
      rule(){
        this.ruleShow = !this.ruleShow;
      },
      prod(prodname){
        this.prodShow = true;
        this.lineProd = false;
        this.appointInfo = true;
        if(prodname != ''){
          this.line = prodname;
        }
      },
      appointment() {
        var that = this;

        if (this.name == '') {
          this.$Modal.warning({
            title: '操作提示',
            content: '您的称呼不能为空'
          });
          return;
        }
        if (this.phone == '' || this.phone.length < 8 || this.phone.length > 11 || this.phone.length == 9 || this.phone.length == 10) {
          this.$Modal.warning({
            title: '操作提示',
            content: '您的联系电话不能为空或者电话号码长度不正确'
          });
          return;
        }
        // if (this.people == '') {
        //   this.$Modal.warning({
        //     title: '操作提示',
        //     content: '出行人数不能为空'
        //   });
        //   return;
        // }
        if (this.line == '') {
          this.$Modal.warning({
            title: '操作提示',
            content: '心水线路不能为空'
          });
          return;
        }
        console.log(this.$store.state.user.OpenId, this.name, this.phone, this.demand, this.people);
        flightApi.appointmentFlight(
            this.$store.state.user.OpenId,
            '分享朋友圈预约',
            this.name,
            this.phone,
            '分享朋友圈预约:' + '出行人数:' + this.people + '心水线路:' + this.line + '优惠券ID' + this.usercoupon + '备注:' + this.demand,
            null,
            null,
          )
          .then(sucRes => {
            this.demand = '';
            this.name = '';
            this.phone = '';
            this.people = '';
            if (sucRes.success == true) {
              this.$Modal.success({
                title: '恭喜您预约成功！转发此链接到朋友圈，邀请朋友参与即享优惠加码！',
                content: sucRes.message
              });
            } else {
              this.$Modal.error({
                title: '很遗憾!预约失败！',
                content: sucRes.message
              });
            }
          });
      },
      jumpDetail(){
        var that = this;
        // window.location.href = 'https://mp.weixin.qq.com/s/21njv-RsqYbc1L0rTLjrQQ';
        if(this.disjump == false){
          this.disjump = true;
          this.coupon = true;
          this.prodShow = true;
          this.Isme =  true;
          this.lineProd = true;
          this.appointInfo = false;
        }
        // this.tenCoupon = true;
        // this.othertenCoupon = true;
        // this.threetenCoupon = true;
        // this.fivetenCoupon = true;

        userApi.GetCardList(this.$store.state.user.OpenId).then(getcardRes => {
          console.log('getcardRes',getcardRes)
          that.cardList = getcardRes.data;
          if(getcardRes.success == false){
            userApi.QueryCardList().then(cardRes => {
              console.log('cardRes',cardRes)
              if(cardRes.success == true && cardRes.totalCount > 0){
                  that.cardList = cardRes.data;
                  cardRes.data.forEach(obj =>{

                    if(obj.ID == 3 || obj.ID == 4 || obj.ID == 5 || obj.ID == 6){
                      userApi.PutCard(obj.ID,that.$store.state.user.OpenId,99999999).then(putRes => {
                        console.log('putRes',putRes)
                        if(putRes.success == true){
                          this.tenCoupon = true;
                          this.othertenCoupon = true;
                          this.threetenCoupon = true;
                          this.fivetenCoupon = true;
                          this.$Modal.success({
                            title: '恭喜您!',
                            content: '领劵成功！'
                          });
                        }
                      })
                    }

                  })
                }
                else if(cardRes.totalCount <= 0){
                  this.$Modal.error({
                    title: '很遗憾!',
                    content:'劵已领完！'
                  });
                  this.tenCoupon = false;
                  this.othertenCoupon = false;
                  this.threetenCoupon = false;
                  this.fivetenCoupon = false;
                }
            })
          }
          else{

            getcardRes.data.forEach(cardObj => {
              if ((cardObj.CardID == 3 && cardObj.CardStatu == 0)||(cardObj.CardID == 4 && cardObj.CardStatu == 0)||(cardObj.CardID == 5 && cardObj.CardStatu == 0)||(cardObj.CardID == 6 && cardObj.CardStatu == 0)) {
                var hascoupon = true
              }
            })
            console.log(this.hascoupon)

            if(this.hascoupon == true){
              this.tenCoupon = false;
              this.othertenCoupon = false;
              this.threetenCoupon = false;
              this.fivetenCoupon = false;

              getcardRes.data.forEach(cardObj => {

                if(cardObj.CardID == 3 && cardObj.CardStatu == 0){
                  this.tenCoupon = true;
                  this.tenID = cardObj.CardID;
                  this.tenTitle = cardObj.Caedinfo.CardTitle;
                }
                if(cardObj.CardID == 4 && cardObj.CardStatu == 0){
                  this.threetenCoupon = true;
                  this.threetenID = cardObj.CardID;
                  this.threetenTitle = cardObj.Caedinfo.CardTitle;
                }
                if(cardObj.CardID == 6 && cardObj.CardStatu == 0){
                  this.othertenCoupon = true;
                  this.othertenID = cardObj.CardID;
                  this.othertenTitle = cardObj.Caedinfo.CardTitle;
                }
                if(cardObj.CardID == 5 && cardObj.CardStatu == 0){
                  this.fivetenCoupon = true;
                  this.fivetenID = cardObj.CardID;
                  this.fivetenTitle = cardObj.Caedinfo.CardTitle;
                }

              })
            }
            else{
              userApi.QueryCardList().then(cardRes => {
                console.log('cardRes',cardRes)
                if(cardRes.success == true && cardRes.totalCount > 0){
                    that.cardList = cardRes.data;
                    cardRes.data.forEach(obj =>{

                      if(obj.ID == 3 || obj.ID == 4 || obj.ID == 5 || obj.ID == 6){
                        userApi.PutCard(obj.ID,that.$store.state.user.OpenId,99999999).then(putRes => {
                          console.log('putRes',putRes)
                          if(putRes.success == true){
                            this.tenCoupon = true;
                            this.othertenCoupon = true;
                            this.threetenCoupon = true;
                            this.fivetenCoupon = true;
                            this.$Modal.success({
                              title: '恭喜您!',
                              content: '领劵成功！'
                            });
                          }
                        })
                      }

                    })
                  }
              })
            }


          }
        })

      },
      userCoupon(id,title){
        console.log(id,title)
        this.isUse = '(已选择'+ title + ')'
        this.usercoupon = id;
        this.prodShow = true;
        this.lineProd = false;
        this.appointInfo = true;
      },
      shopFriend(){
        var that = this;
        wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
          wx.updateTimelineShareData({
            title: '快来参与携程旅游候机楼门的百万旅游红包活动，我已经领取了100元，更多旅游线路等您来看，分享朋友圈可活优惠加码～', // 分享标题
            link: 'http://www.callmefix.net/wechat/TravelAppointment/'+that.$store.state.user.OpenId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://www.callmefix.net/img/travelAppointment.jpg', // 分享图标
            success: function () {
              // 设置成功
              flightApi.saveSearchFlightRecord1(this.$store.state.user.OpenId,this.$store.state.user.OpenId,1, baseTool.formatterDate(new Date()),'分享朋友圈记录',this.phoneType).then(sucRes => {})
            }
          })
        });
      },
    },
  };
</script>

<style>
  *{
    -webkit-overflow-scrolling: touch;
  }
  body {
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
  }

  .img{
    width: 96%;
    margin: 0 2%;
    border: 1px solid #bfbfbf;
    margin-bottom: 5px;
  }

  .demand{
    width: 96%;
    border: 1px solid #bfbfbf;
    margin: 10px 2%;
  }

  .infomation{
    width: 96%;
    margin: 0 2%;
    border: 1px solid #bfbfbf;
  }

  .lineProd{
    width: 96%;
    margin: 0 2%;
    /* border: 1px solid #bfbfbf; */
    margin-bottom: 10px;
  }

  .appointment {
    width: 94%;
    margin: 10px 3% 0 3%;
    background: #2754bb;
    color: white;
    height: 40px;
    font-size: 18px;
    border: 0;
    border-radius: 5px;
    line-height: 10px;
    /* margin-bottom: 10px; */
  }
/*  .ivu-progress{
    display: flex;
    justify-content: flex-start;

  } */
  /* .ivu-progress .ivu-progress-text{
    width: 70px;
  } */
 .ivu-progress .ivu-progress-outer{
   padding-right: 10px;
  }
  .ivu-progress .ivu-progress-inner{
    border: #c6c6c6 solid 1px;
  }
  .ivu-progress .ivu-progress-bg{
    height: auto !important;
  }
  /* .ivu-steps{
    margin-left: 10px;
  }
  .ivu-steps .ivu-steps-head{
    display: flex;
    flex-direction: column;
  }
  .ivu-steps .ivu-steps-main{
    margin-left: 10px;
  } */
  input::-webkit-input-placeholder {
    color: #515A6E;
  }

  input::-moz-input-placeholder {
    color: #515A6E;
  }

  input::-ms-input-placeholder {
    color: #515A6E;
  }

  .top_recognition {
    /* margin: 0 0 10px 0; */
  }

  .recognition {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/travelAppointment.vue